import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useLayoutEffect } from 'react';
import useRect from '../../../hooks/useRect.js';

var BOUNDARY_MARGIN = 16;
var usePositionOffset = function usePositionOffset() {
  var boundaryMargin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BOUNDARY_MARGIN;
  var _useRect = useRect(100),
    _useRect2 = _slicedToArray(_useRect, 2),
    anchorRef = _useRect2[0],
    anchorRect = _useRect2[1];
  var _useRect3 = useRect(100),
    _useRect4 = _slicedToArray(_useRect3, 2),
    floatingRef = _useRect4[0],
    floatingRect = _useRect4[1];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    offsetTopPosition = _useState2[0],
    setOffsetTopPosition = _useState2[1];
  var calculateTopOffset = function calculateTopOffset() {
    if (!floatingRect || !anchorRect) return;
    var windowHeight = window.innerHeight;
    var anchorRectTop = anchorRect.top;
    var floatingRectHeight = floatingRect.height;
    var offsetTop = anchorRectTop;
    var exceedsBottomBoundary = anchorRectTop + floatingRectHeight > windowHeight - boundaryMargin;
    var exceedsTopBoundary = anchorRectTop < boundaryMargin;
    if (exceedsBottomBoundary) {
      offsetTop = Math.max(boundaryMargin, windowHeight - boundaryMargin - floatingRectHeight);
    } else if (exceedsTopBoundary && offsetTop !== 0) {
      offsetTop = boundaryMargin;
    }
    setOffsetTopPosition(offsetTop);
  };
  useLayoutEffect(function () {
    calculateTopOffset();
  }, [anchorRect, floatingRect]);
  return {
    anchorRef: anchorRef,
    calculateTopOffset: calculateTopOffset,
    floatingRef: floatingRef,
    offsetTopPosition: offsetTopPosition
  };
};

export { usePositionOffset };
//# sourceMappingURL=usePositionOffset.js.map
